import { render, staticRenderFns } from "./HomeBody.vue?vue&type=template&id=57e5e4f8&scoped=true"
import script from "./HomeBody.vue?vue&type=script&lang=js"
export * from "./HomeBody.vue?vue&type=script&lang=js"
import style0 from "./HomeBody.vue?vue&type=style&index=0&id=57e5e4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5e4f8",
  null
  
)

export default component.exports